import React from "react";
import { useTranslation } from "react-i18next";
import "./OfflineStatus.scss";

interface OfflineStatusProps {
  isOffline: boolean;
  isSyncing?: boolean;
  isUsingSavedData?: boolean;
  queuedOperationsCount: number;
  className?: string;
}

export const OfflineStatus: React.FC<OfflineStatusProps> = ({
  isOffline,
  isSyncing = false,
  isUsingSavedData = false,
  queuedOperationsCount,
  className = "",
}) => {
  const { t } = useTranslation();
  const getStatusIcon = (): string => {
    if (isSyncing) return "";
    if (isOffline) return "";
    if (queuedOperationsCount > 0) return "⏳";
    return "";
  };

  const getStatusText = (): string => {
    if (isSyncing) return t("offline_status.syncing");
    if (isOffline) return t("offline_status.offline");
    if (isUsingSavedData) return t("offline_status.saved");
    if (queuedOperationsCount > 0) return t("offline_status.pending_sync");
    return t("offline_status.online");
  };

  const getStatusClass = (): string => {
    if (isSyncing) return "syncing";
    if (isOffline) return "offline";
    if (isUsingSavedData) return "saved";
    if (queuedOperationsCount > 0) return "pending";
    return "online";
  };

  return (
    <div className={`offline-status ${getStatusClass()} ${className}`}>
      <div className="status-indicator">
        <span
          className="status-icon"
          role="img"
          aria-label={t("offline_status.connection_status") as string}
        >
          {getStatusIcon()}
        </span>
        <span className="status-text">{getStatusText()}</span>
      </div>
    </div>
  );
};
